export function searchArticles (params = {})
{
    var url = new URL(window.location.origin + '/wp-json/ncel/v1/news')
    Object
        .keys(params)
        .forEach(key => url.searchParams.append(key, params[key]))

    return fetch(url);
}